export default "__VITE_ASSET__ozHA1f3n__"